import Vue from 'vue'
import VueTheMask from 'vue-the-mask'
import wysiwyg from 'vue-wysiwyg'
import VueObserveVisibility from 'vue-observe-visibility'
import VuexRouterSync from 'vuex-router-sync';
import Notifications from './components/material/Notification'
import { Plugin } from 'vue-fragment'

import './prototypes'
import './components'
import './modules'
// import './listeners'
import plugins from './plugins'

import App from './App.vue'
import router from '@/router'
import store from '@/store'
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.use(VueTheMask)
Vue.use(wysiwyg, { hideModules: { "image": true } })
Vue.use(VueObserveVisibility)
Vue.use(Notifications)
Vue.use(Plugin)

VuexRouterSync.sync(store, router);

Vue.prototype.$appName = process.env.VUE_APP_TITLE

new Vue({
  store,
  router,
  ...plugins,
  render: h => h(App)
}).$mount('#app')
